import PropTypes from 'prop-types';
import { viewShape } from './view';
import { FETCHING_STATUS } from '../../../constants';

export const reportShape = PropTypes.shape({
  views: PropTypes.arrayOf(viewShape),
  fetchingStatus: PropTypes.oneOf(Object.values(FETCHING_STATUS)).isRequired,
});
